export const visit = (vm, at) => {
vm(require("commerce-contract-lib/lang/en.lyaml"));
at({ "en": { "attributionCards": { "title": { "contactCreateAttribution": "Contact create attribution", "dealCreateAttribution": "Deal create attribution", "revenueAttribution": "Revenue attribution" } } } });
};